import { Abstrap } from '../..';

const { propTypes } = Abstrap;

const defaultProps = { ...Abstrap.defaultProps, componentClass: 'tbody' };

class TableBody extends Abstrap {

    getClassNameSchema() {
        const {
            className,
        } = this.props;
        return [
            'c-table__body',
            className,
        ];
    }

}

TableBody.propTypes = propTypes;

TableBody.defaultProps = defaultProps;

export default TableBody;
